import React from "react";
import { Link } from "react-router-dom";

export const getLinkedinUrn = (linkedinId: string) => {
  if (linkedinId.startsWith("urn:li")) {
    return linkedinId;
  }
  return `urn:li:share:${linkedinId}`;
};

type LinkedinLinkProps = Omit<React.ComponentProps<typeof Link>, "to"> & {
  children: React.ReactNode;
  linkedinId: string;
};

const LinkedinLink: React.FC<LinkedinLinkProps> = ({ children, linkedinId, tabIndex }) => (
  <a href={`https://www.linkedin.com/feed/update/${getLinkedinUrn(linkedinId)}`} target="_blank" rel="noopener noreferrer" tabIndex={tabIndex || 0}>
    {children}
  </a>
);

export default LinkedinLink;
